import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';
import { MATCHING_QUERY_KEY } from '../candidate-project-matching/useRecommendations';

export const useUpdateProject = () => {
  const queryClient = useQueryClient();
  return usePost({
    url: ApiRoutesEnum.updateProject,
    onSuccess: () => { void queryClient.invalidateQueries([MATCHING_QUERY_KEY]); },
  });
};
